import { navigate } from '@reach/router'
import types from '../actiontypes'

export const RoutePush = (pathname, search, hash) => {
  return {
    type: types.Router.Push,
    payload: {
      pathname,
      search,
      hash
    }
  }
}

export const RoutePushDispatch = (dispatch) => {
  return (pathname, search, hash) => {
    dispatch(RoutePush(pathname, search, hash))
  }
}

export const RouteAddIndexRoute = (pathname) => {
  return {
    type: types.Router.AddIndexRoute,
    payload: pathname
  }
}

export const RouteAddIndexRouteDispatch = (dispatch) => {
  return (pathname) => {
    dispatch(RouteAddIndexRoute(pathname))
  }
}

export const sendToURL = (dispatch) => {
  return (url, state = {}, replace = false) => {
    return navigate(url, { state, replace })
  }
}
